import React, { useEffect } from "react";
import * as XLSX from "xlsx";
import Heading from "../../tailwindUI/Heading";
import Navbar from "../../tailwindUI/Navbar";
import classes from "../../module.css/EdpDashboard.module.css";
import { useState } from "react";
import Input from "../../tailwindUI/Input";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import Button from "../../tailwindUI/Button";
import StatsCard from "../../tailwindUI/StatsCard";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import EDPTableCopyClipBoard from "../../Components/EDPTableCopyClipBoard";
// import Modal from "../../tailwindUI/Modal";
import { useRef } from "react";
import { useCallback } from "react";
import { MdOutlineCancel } from "react-icons/md";
import EDPNewExcelEntry from "../../Components/EDPNewExcelEntry";
import NewModal from "../../tailwindUI/NewModal";

const EdpDashboard = () => {
  const navigate = useNavigate();
  const [input, setInput] = useState("");
  const [message, setMessage] = useState("");
  const [edpfileupdateMessage, setEdpfileUpdateMessage] = useState("");
  const [loading, setloading] = useState(false);
  const [apiFailled, setApiFailled] = useState(false);
  const [reason, setReason] = useState("");
  const [errorRreason, setErrorReason] = useState("");
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  // Pending Upload States
  const [pendingInput, setPendingInput] = useState("");
  const [pendingUploadError, setPendingUploadError] = useState("");
  const [pendingMessage, setPendingMessage] = useState("");
  const [reportType, setReportType] = useState("edp"); // "edp" or "pending"
  const [pendingEntryData, setPendingEntryData] = useState([]);
  // States
  const [initialData, setInitialData] = useState([]); // Original API data
  const [tableData, setTableData] = useState([]); // Editable table data
  const [newEntry, setNewEntry] = useState("");

  const [eDPStockcountOfCarCount, setEDPStockcountOfCar] = useState({
    InTransitcar: "",
    PendingDeliveries: "",
    Pendingcar: "",
    Physicalcar: "",
    Totalcar: "",
  });
  const [modelWiseDLD, setModelWiseDLD] = useState([]);
  const [totalStockModelWise, setTotalStockModelWise] = useState([]);
  const [loadingSingleData, setLoadingSignleData] = useState(false);
  const users = localStorage.getItem("UserToken");

  // const [tableData, setTableData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // New state for showing the modal
  const [hasMore, setHasMore] = useState(true); // To control if there is more data to load
  const [page, setPage] = useState(1); // Track the current page for pagination

  const tableContainerRef = useRef(null); // Create a ref for the table container

  useEffect(() => {
    EDPStockcountOfCar();
    EDPstockdeliveredmodelwise();
    EDPNewEntry();
  }, []);

  console.log("showmodal", showModal);

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };

  const excelUpload = () => {
    setloading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);

    var formdata = new FormData();
    formdata.append("UserToken", users);
    formdata.append("StockExcel", input);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/edp/EDPExcelStockAdd`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "Update Varients"
        ) {
          setInitialData(
            result.ConcatVinData.map((item) => {
              return { ...item, enabled: true, error: "" };
            })
          );
          setTableData(
            result.ConcatVinData.map((item) => {
              return { ...item, enabled: true, error: "" };
            })
          );
          setShowModal(true);
          EDPNewEntry();
          EDPStockcountOfCar();
          EDPstockdeliveredmodelwise();

          setApiFailled(false);
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "Stock not Found"
        ) {
          setMessage("Data Imported Successfully!");
          EDPStockcountOfCar();
          EDPNewEntry();
          EDPstockdeliveredmodelwise();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.message === "Stock Already Exists"
        ) {
          setMessage("Stock Data Already Exists!");
          EDPStockcountOfCar();
          EDPNewEntry();
          EDPstockdeliveredmodelwise();
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => {
        setloading(false);
      });
  };

  const excelUpdate = (data) => {
    // setloading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);

    var formdata = new FormData();
    formdata.append("UserToken", users);
    formdata.append("data", JSON.stringify(data));

    // formdata.append("serializerdata", JSON.stringify(data));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/edp/EDPExcelStockUpdate`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        if (result.status_code === 200 && result.status === "Success") {
          if (
            result.message ==
            "Same Varient has in our database but sepcification code is different"
          ) {
            setErrorReason(
              "Please update Variant Name as same Variant Name already exists with a different Specification Code"
            );
            // setMessage("There is an error")
            // console.log(result.reason,"11111");
            setShowModal(true);
          } else {
            setErrorReason("");
            setReason("");
            setEdpfileUpdateMessage("Data updated successfully!");
            // setLoadingSignleData(false)
            // setTableData(result.data);
            setShowModal(false);
            setMessage("Data Updated Successfully");
            EDPNewEntry();
            EDPStockcountOfCar();
            EDPstockdeliveredmodelwise();
          }
          // setMessage(result.message);
          // setApiFailled(false);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
          // setReason("There is an error!!");
          setErrorMessage("Something went wrong please contact support1 !");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => {
        setloading(false);
      });
  };

  const EDPStockcountOfCar = () => {
    setloading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/edp/EDPStockcountOfCar`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "fail" &&
          result.data ===
          "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data === "You dont have permission to access model list" &&
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setEDPStockcountOfCar({
            InTransitcar: result.InTransitcar,
            PendingDeliveries: result.PendingDeliveries,
            Pendingcar: result.Pendingcar,
            Physicalcar: result.Physicalcar,
            Totalcar: result.Totalcar,
          });
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setloading(false));
  };

  const EDPNewEntry = () => {
    setloading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/edp/EDPExcelStockNewEntryList`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "fail" &&
          result.data ===
          "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data === "You dont have permission to access model list" &&
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status_code === 200 && result.status === "Success") {
          setNewEntry(result.data);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setloading(false));
  };

  const EDPstockdeliveredmodelwise = () => {
    setloading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", process.env.REACT_APP_AUTH_TOKEN);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/stockone/edp/EDPstockdeliveredmodelwise`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data ===
          "Invalid User Token, The token may have expired, You may need to re-login" &&
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login"
        ) {
          LogOut();
        } else if (
          result.status_code === 200 &&
          result.status === "Success" &&
          result.data === "You dont have permission to access model list" &&
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (result.status === "Success") {
          setModelWiseDLD(result.stockdeliveredmodelwise);
          setTotalStockModelWise(result.freestock);
        } else {
          setApiFailled(true);
          setMessage(result.Reason);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong please contact support !");
      })
      .finally(() => setloading(false));
  };

  const successMessage = () => {
    setTimeout(() => {
      setMessage("");
    }, 3000);
    return message;
  };

  const validateInput = () => {
    const newErrors = {};
    const selectedRows = tableData.filter((row) => row.enabled);

    // Collect all variant values for selected rows
    const variants = selectedRows.map((row) => row.Variant);

    tableData.forEach((row) => {
      if (!row.Variant) {
        // Check for empty input
        row["error"] = "Variant cannot be empty";
      } else if (
        variants.filter((variant) => variant === row.Variant).length > 1
      ) {
        // Check for duplicate Variant values
        row["error"] = "Variant must be unique";
      }
    });
    console.log(tableData);
    setErrors(newErrors);

    // Return true if no errors
    return tableData.filter((item) => item.error !== "").length === 0;
  };

  // const handleInputChange = (index, key, value) => {
  //   const updatedData = [...tableData];
  //   updatedData[index][key] = value;

  //   // Remove error for the field if the value changes
  //   if (errors[index]) {
  //     const updatedErrors = { ...errors };
  //     delete updatedErrors[index];
  //     setErrors(updatedErrors);
  //   }

  //   setTableData(updatedData);
  // };

  // const handleChange = (event) => {
  //   event.target.files[0].name.match(/\.(xls[mx]?)$/)
  //     ? setInput(event.target.files[0])
  //     : setUploadError(
  //       "Please upload valid excel file .xlsx, .xlsm, .xls only."
  //     );
  // };

  const handleChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      // Reset error and success messages
      setUploadError("");
      setMessage("");

      // Validate the file extension
      const isValidFile = file.name.match(/\.(xls[mx]?)$/);

      if (isValidFile) {
        setInput(file); // Set the uploaded file
        // setMessage("Data Imported Successfully"); // Display success message
      } else {
        setUploadError(
          "Please upload valid excel file (.xlsx, .xlsm, .xls only)."
        );
      }
    }
  };

  const handlePendingChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setPendingUploadError("");
      setPendingMessage("");

      const isValidFile = file.name.match(/\.(xls[mx]?)$/);

      if (isValidFile) {
        setPendingInput(file);
      } else {
        setPendingUploadError(
          "Please upload valid excel file (.xlsx, .xlsm, .xls only)."
        );
      }
    }
  };

  // Import xlsx at the top (I will add the import in a separate step or assume it's there if I can multi-edit, but I'll do it here if possible or just rely on the tool finding the top).
  // Actually, I can't add imports at the top with this range. I will add the import in a separate call.

  const pendingExcelUpload = () => {
    setloading(true);

    const file = pendingInput;
    if (!file) {
      setloading(false);
      return;
    }

    var formdata = new FormData();
    formdata.append("pendingExcel", file);

    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/pendingExcelUpload`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (Array.isArray(result)) {
          const mappedData = result.map((item) => ({
            OrderDate: item.created_at,
            OrderNo: item.OrderId,
            Model: item.model_name,
            Variant: item.variant,
            Color: item.colour,
            VinNo: item.win_num,
            OrderStatus: item.carstatus || item.status
          }));
          setPendingEntryData(mappedData);
          setReportType("pending");
          setPendingMessage("Pending Data Uploaded and Fetched Successfully!");
        } else {
          setPendingMessage("Uploaded successfully but received invalid data format.");
        }

      })
      .catch((error) => {
        console.log("error", error);
        setPendingMessage("Failed to upload file.");
      })
      .finally(() => {
        setloading(false);
      });
  };

  const formValidation = () => {
    let errors = {};
    let isValid = true;
    if (!input || input === "") {
      isValid = false;
      errors.input = "Please select a file";
    }
    setError(errors);
    return isValid;
  };

  const pendingFormValidation = () => {
    let errors = {};
    let isValid = true;
    if (!pendingInput || pendingInput === "") {
      isValid = false;
      // You might want to set a specific error state for pending input here
      setPendingUploadError("Please select a file");
    }
    return isValid;
  };

  const data = [
    {
      model_name: "Total",
      count: eDPStockcountOfCarCount.Totalcar,
      url: "/edp-stock-details",
      icon: "../assets/logos/total.png",
    },
    {
      model_name: "Pending",
      count: eDPStockcountOfCarCount.Pendingcar,
      url: "/edp-stock-details?term=Pending",
      icon: "../assets/logos/pending.png",
    },
    {
      model_name: "InTransit",
      count: eDPStockcountOfCarCount.InTransitcar,
      url: "/edp-stock-details?term=InTransit",
      icon: "../assets/logos/transit.png",
    },
    {
      model_name: "Physical",
      count: eDPStockcountOfCarCount.Physicalcar,
      url: "/edp-stock-details?term=Physical",
      icon: "../assets/logos/physical.png",
    },
    {
      model_name: "Pending Deliveries",
      count: eDPStockcountOfCarCount.PendingDeliveries,
      url: "/edp-manage-delivery",
      icon: "../assets/logos/delivered.png",
    },
  ];

  const handleInputChange = (index, field, value) => {
    const updatedData = [...tableData];
    updatedData[index][field] = value;
    updatedData[index]["error"] = "";
    setTableData(updatedData);
  };

  const handleScroll = useCallback(
    (e) => {
      const bottom =
        e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;

      if (bottom && hasMore && !loading) {
        setPage((prevPage) => prevPage + 1); // Increment the page to fetch next chunk
      }
    },
    [hasMore, loading]
  );

  useEffect(() => {
    const tableElement = tableContainerRef.current;
    if (tableElement) {
      tableElement.addEventListener("scroll", handleScroll);
    }

    // Cleanup event listener on component unmount
    return () => {
      if (tableElement) {
        tableElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  const fetchPendingReport = () => {
    setloading(true);
    var requestOptions = {
      method: "POST",
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_N8N_WEBHOOK_BASE_URL}/pendingExcelUploadReport`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (Array.isArray(result)) {
          console.log("Pending Report Data:", result);
          const mappedData = result.map((item) => ({
            OrderDate: item.created_at,
            OrderNo: item.OrderId,
            Model: item.model_name,
            Variant: item.variant,
            Color: item.colour,
            VinNo: item.win_num,
            OrderStatus: item.carstatus || item.status
          }));
          setPendingEntryData(mappedData);
        } else {
          setPendingMessage("Failed to fetch pending report data.");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setErrorMessage("Something went wrong while fetching pending report!");
      })
      .finally(() => {
        setloading(false);
      });
  };

  useEffect(() => {
    if (reportType === "pending") {
      fetchPendingReport();
    }
  }, [reportType]);

  // const toggelSelect = (updatedObject) => {
  //   console.log(updatedObject);

  //   const updatedData = tableData.map((item) =>
  //     item.VinNumber === updatedObject.VinNumber
  //       ? { ...item, enabled: !updatedObject.enabled }
  //       : item
  //   );
  //   setTableData(updatedData);
  // };

  // const updateAllDetails = () => {
  //   const enalbedData = tableData.filter((item) => item.enabled);
  //   const finalData = enalbedData.map((item) => {
  //     return {
  //       Model: item.Model,
  //       varient: item.Variant,
  //       SpecificationCode: item.FullSpecCode,
  //       VinNO: item.VinNumber,
  //     };
  //   });

  //   excelUpdate(finalData);
  // };

  const toggelSelect = (row) => {
    const updatedData = tableData.map((item) => {
      if (item.VinNumber === row.VinNumber) {
        return { ...item, enabled: !item.enabled, error: "" };
      }
      return item;
    });

    setTableData(updatedData);

    // Reset errors when toggling selection
    setErrors({});
  };
  const transformData = (data) => {
    const result = [];
    data.forEach((item) => {
      const vinNumbers = item.VinNumber.split(","); // Split comma-separated VINs
      vinNumbers.forEach((vin) => {
        result.push({
          Model: item.Model,
          varient: item.Variant?.trim(),
          SpecificationCode: item.FullSpecCode,
          VinNO: vin,
        });
      });
    });
    return result;
  };
  const updateAllDetails = () => {
    if (validateInput()) {
      const enabledData = tableData.filter((item) => item.enabled);
      const finalData = transformData(enabledData);
      excelUpdate(finalData); // Proceed with the update
    } else {
      console.log("Validation failed");
    }
  };
  const isDisabled = tableData.filter((item) => item.enabled).length === 0;
  // Add space after each comma
  const formattedVinNumbers = (vinNumbers) => vinNumbers.replace(/,/g, ", ");

  if (loading && page === 1) {
    <img
      src="../assets/loadingGif.gif"
      alt="loading"
      className={classes.loader}
    />;
  }

  return (
    <>
      {message && (
        <SuccessMessage
          onClose={() => setMessage("")}
          message={successMessage()}
          apiFailled={apiFailled}
        />
      )}
      {pendingMessage && (
        <SuccessMessage
          onClose={() => setPendingMessage("")}
          message={pendingMessage}
          apiFailled={false}
        />
      )}

      {!reason && errorMessage && <ErrorMessage message={errorMessage} />}

      <NewModal
        type="EDD stock add"
        setOpen={() => {
          setErrorReason("");
          setReason("");
          setShowModal(!showModal);
        }}
        open={showModal}
      >
        <div className="modal-content bg-white rounded-lg max-w-7xl w-full h-fit overflow-hidden">
          {reason && <ErrorMessage message={reason} />}

          <div className="flex justify-between items-center mb-4">
            <h2 className="text-2xl font-semibold text-gray-800 ">
              Vehicle Data Table
            </h2>
            <button
              className="mt-4  text-red-500 "
              onClick={() => {
                setErrorReason("");
                setReason("");
                setShowModal(false);
              }} // Close the modal
            >
              <MdOutlineCancel className="h-8 w-6 -mt-6" />
            </button>
          </div>
          <div ref={tableContainerRef} className="overflow-y-auto max-h-[70vh]">
            <table className="table-auto border-collapse border border-gray-300 rounded-lg overflow-hidden w-full">
              <thead>
                <tr className="bg-blue-600 text-white">
                  <th className="border border-gray-300 p-4 text-left max-w-lg">
                    VIN Number(s)
                  </th>
                  <th className="border border-gray-300 p-4 text-left">
                    Full Spec Code
                  </th>
                  <th className="border border-gray-300 p-4 text-left">
                    Variant
                  </th>
                  <th className="border border-gray-300 p-4 text-left">
                    Select
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-100 transition-all duration-200 ease-in-out"
                  >
                    <td className="border-2 border-gray-300 p-4 max-w-lg break-words">
                      {formattedVinNumbers(row.VinNumber)}
                    </td>
                    <td className="border-2 border-gray-300 p-4">
                      {row.FullSpecCode}
                    </td>
                    <td className="border-2 border-gray-300 p-4">
                      <input
                        type="text"
                        value={row.Variant}
                        onChange={(e) =>
                          handleInputChange(index, "Variant", e.target.value)
                        }
                        className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 ${row.error ? "border-red-500" : "border-gray-300"
                          }`}
                        placeholder="Enter variant"
                        disabled={!row.enabled} // Disable input for unchecked rows
                      />
                      {row.error && (
                        <p className="text-red-500 text-sm">{row.error}</p>
                      )}
                    </td>
                    <td className="border-2 border-gray-300 p-4">
                      <div className="flex items-center justify-center space-x-2">
                        <input
                          type="checkbox"
                          id={`checkbox-${index}`}
                          checked={row.enabled}
                          onChange={() => toggelSelect(row)}
                          className="w-5 h-5 cursor-pointer text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                        />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-6 flex items-center justify-between">
            <div></div>
            <div className="text-red-500 text-sm font-semibold">
              {errorRreason}
            </div>

            <button
              type="button"
              onClick={() => updateAllDetails()}
              disabled={isDisabled}
              className={`bg-green-500 text-white px-6 py-3 rounded-lg ${isDisabled
                ? "opacity-50 cursor-not-allowed"
                : "hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                }`}
            >
              Confirm Import
            </button>
          </div>
        </div>
      </NewModal>

      <Navbar navbarType={"blue navbar"} />
      {loading ? (
        <img
          src="../assets/loadingGif.gif"
          alt="loading"
          className={classes.loader}
        />
      ) : (
        <div className={classes.maincontainer}>
          <Heading headingType={"Page Headings"} headingText={"Dashboard"} />

          <div className={classes.background}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <Input
                  type={"input with label"}
                  inputType="file"
                  label="Add Stock From Excel"
                  // onInput={() => (error.input = "")}
                  onChange={handleChange}
                />
                <span className="error">
                  {uploadError ? uploadError : error.input}
                </span>

                <div className="mt-4">
                  <Button
                    loading={loading}
                    type="redFilled"
                    buttonText="Submit"
                    onClick={() =>
                      formValidation() ? excelUpload() : console.log("err")
                    }
                  />
                </div>
              </div>

              <div>
                <Input
                  type={"input with label"}
                  inputType="file"
                  label="Pending Stock"
                  onChange={handlePendingChange}
                />
                <span className="error">
                  {pendingUploadError}
                </span>

                <div className="mt-4">
                  <Button
                    loading={loading}
                    type="redFilled"
                    buttonText="Submit"
                    onClick={() =>
                      pendingFormValidation() ? pendingExcelUpload() : console.log("pending err")
                    }
                  />
                </div>
              </div>
            </div>

            <div className="flex items-center justify-end my-4">
              <span className="mr-3 text-sm font-medium text-gray-900">
                {reportType === "edp" ? "EDP Status Report" : "Pending Report"}
              </span>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  className="sr-only peer"
                  onChange={() => setReportType(prev => prev === "edp" ? "pending" : "edp")}
                  checked={reportType === "pending"}
                />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
              </label>
            </div>

            {/* <p>jhkgdugdhkjd</p> */}
            <div>
              <EDPNewExcelEntry
                newEntry={reportType === "edp" ? newEntry : pendingEntryData}
                title={reportType === "edp" ? "EDP Status Report" : "Pending Report"}
              />
            </div>

            <StatsCard
              type="EDP Total Real Time Stock ui changes"
              data={data}
              typewidth={"width"}
            />
            <div className="flex items-start my-4 gap-4">
              <EDPTableCopyClipBoard
                data={modelWiseDLD}
                caption="Model Wise Delivered"
                className=" border-indigo-600 bg-indigo-700 text-white font-semibold cursor-pointer py-2"
              />
              <EDPTableCopyClipBoard
                data={totalStockModelWise}
                caption="Total Stock Model Wise"
                className="border-pink-600 bg-pink-700 text-white font-semibold cursor-pointer py-2"
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EdpDashboard;
